import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstKey'
})
export class FirstKeyPipe implements PipeTransform {
  transform(object: any): string {
    if (!object) {
      return undefined;
    }
    const keys = Object.keys(object);

    return keys.length > 0 ? keys[0] : undefined;
  }
}
